import styled from "styled-components";
import customMedia from "../../config/breakpoints";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Bloc = styled.div<{ index: number }>`
  align-items: ${({ index }) => (index === 0 ? "flex-start" : "center")};
  background: ${({ theme }) => theme.colors.blueLight};
  display: flex;
  flex-direction: row;
  padding: 32px 40px;

  ${customMedia.lessThan("mobile")`
    flex-direction: column;
  `}

  ul {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-left: 12px;
  }

  li {
    line-height: 26px;
  }
`;

export const Title = styled.div`
  background: ${({ theme }) => theme.colors.blueLight};
  display: flex;
  padding: 32px 40px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 90%;

  ${customMedia.lessThan("mobile")`
    width: 100%;
    padding: 0px;
  `}

  ul {
    margin-left: 36px;
  }

  a {
    color: ${({ theme }) => theme.colors.blue};
    text-decoration: underline;
    transition: all 0.3s ease;

    &:hover {
      font-weight: 600;
    }
  }
`;
export const StepContainer = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  width: 10%;
  margin-right: 24px;
  height: 100%;

  ${customMedia.lessThan("mobile")`
    width: 100%;
    margin-bottom:16px;
    justify-content:flex-start;
    margin-right: 0px;
  `}
`;

export const Step = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.colors.blue};
  border-radius: 200px;
  min-height: 50px;
  min-width: 50px;
`;
